<!--
 * @Author: lishun
 * @Date: 2019-11-22 11:36:59
 * @LastEditors: fengzhongmei
 * @LastEditTime: 2020-08-06 11:09:56
 * @Description: bug16673添加字段
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
 -->
<template>
    <div class="layout-rctable-container env-mgtvpc">
        <helpInfo :helpData="helpData">
            <div slot="slotR"
                 class="back-div"
                 @click="$router.go(-1)">
                <Icon type="ios-arrow-dropleft"
                      size="16" />
                <span>{{$t('返回')}}</span>
            </div>
        </helpInfo>
        <div class="table-container"
             style="padding:15px;">
            <Tabs style="min-height: 100%;"
                  type='card'
                  name="1"
                  v-model="tabValue"
                  :animated="false">
                <TabPane :label="$t('入方向')"
                         name="1">
                    <setruletable type="ingress"
                                  :vpc="vpc"
                                  :tableData="tableData" />
                </TabPane>
                <TabPane :label="$t('出方向')"
                         name="2">
                    <setruletable type="egress"
                                  :vpc="vpc"
                                  :tableData="tableData" />
                </TabPane>
            </Tabs>
        </div>
    </div>
</template>

<script>
import helpInfo from '@/views/components/basic/helpinfo.vue'
import setruletable from './setruletable.vue'
import eventBus from '@/service/eventbus.js'
export default {
    name: 'settingrule',
    components: {
        helpInfo,
        setruletable
    },
    data () {
        return {
            securityId: this.$route.params.id,
            vpc: this.$route.query.vpc,
            tabValue: '1',
            tableData: [],
            helpData: {
                modelName: `${this.$route.query.envName} - ${this.$route.query.securityName} - 配置规则`,
                type: ''
            }
        }
    },
    mounted () {
        eventBus.$emit('setSecurityId', { securityId: this.$route.params.id, id: this.$route.params.id, envId: this.$route.query.envId })
    },
    methods: {
        goBackTo () {
            this.$router.push({
                path: `/mgt/securitygroup/${this.$route.query.envId}`,
                query: {
                    envType: this.$route.query.envType,
                    envName: this.$route.query.envName
                }
            })
        }
    }
}
</script>
